var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 32,
    viewBox: "0 0 16 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h16v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M14.24 9.176c-.15-.413-.582-.657-.582-.657h-2.91s-2.364 1.22-5.48 1.22c-3.116 0-5.125-1.22-5.125-1.22h-3.06v11.336h3.06s2.009-1.22 5.125-1.22 5.48 1.22 5.48 1.22h2.91s.432-.244.582-.657c.15-.413.15-.976.15-.976s-1.163-1.688-1.163-4.035c0-2.347 1.163-4.035 1.163-4.035s0-.563-.15-.976"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7F899A",
    fillOpacity: 0.25,
    d: "M11.405 23.77V10.105H2.981V5.18a.609.609 0 0 0-1.217 0v4.925H.069V23.77L1.7 27.412h8.071l1.633-3.642z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303845",
    d: "M3.004 10.105V5.18a.609.609 0 0 0-1.217 0v4.925h1.217z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303845",
    d: "M11.405 10.105v-.563c0-1.577-.469-2.778-.938-3.247-.413-.413-1.537-.652-3.755-.703l-.506.721H4.29l-.48-.684c-1.597.092-2.455.317-2.804.666C.538 6.764.07 7.965.07 9.542v.563h11.336z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 3.451 16.473)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7F899A",
    fillOpacity: 0.5,
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#303845",
    transform: "translate(7.511 14.272)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.743,
    cy: 0.743,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.743,
    cy: 2.686,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.743,
    cy: 4.629,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.743,
    cy: 6.571,
    r: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceNormal);
export default __webpack_public_path__ + "static/media/device_normal.7be39290809a54afc4dfb3440f6cf313.svg";
export { ForwardRef as ReactComponent };